import React, { useState, useEffect } from 'react';

const AutoSuggestInput = ({ allItems = [], onSelectionChange, initialSelected = [] }) => {
    const [inputValue, setInputValue] = useState("");
    const [selectedItems, setSelectedItems] = useState(initialSelected);

    // Update internal state when initialSelected prop changes
    useEffect(() => {
        setSelectedItems(initialSelected);
    }, [initialSelected]);

    const handleInputChange = (e) => {
        setInputValue(e.target.value);
    };

    // Filter suggestions based on input and remove items already selected
    const filteredSuggestions = allItems.filter(item =>
        item.itemName.toLowerCase().includes(inputValue.toLowerCase()) &&
        !selectedItems.some(selected => selected._id === item._id)
    );

    const handleSuggestionClick = (item) => {
        const newSelected = [...selectedItems, item];
        setSelectedItems(newSelected);
        onSelectionChange(newSelected);
        setInputValue("");
    };

    const handleRemoveItem = (id) => {
        const newSelected = selectedItems.filter(item => item._id !== id);
        setSelectedItems(newSelected);
        onSelectionChange(newSelected);
    };

    return (
        <div className="relative w-full">
            <input
                type="text"
                placeholder="Type to search suggested items..."
                value={inputValue}
                onChange={handleInputChange}
                className="border p-2 w-full"
            />
            {inputValue && filteredSuggestions.length > 0 && (
                <div className="absolute z-10 bg-white border mt-1 w-full rounded shadow">
                    {filteredSuggestions.map(item => (
                        <div
                            key={item._id}
                            onClick={() => handleSuggestionClick(item)}
                            className="cursor-pointer p-2 hover:bg-gray-200"
                        >
                            {item.itemName}
                        </div>
                    ))}
                </div>
            )}
            {selectedItems.length > 0 && (
                <div className="mt-2">
                    {selectedItems.map(item => (
                        <span
                            key={item._id}
                            className="inline-flex items-center bg-gray-200 text-sm rounded-full px-2 py-1 mr-2"
                        >
                            {item.itemName}
                            <button
                                onClick={() => handleRemoveItem(item._id)}
                                className="ml-1 text-red-600 hover:text-red-800"
                            >
                                &times;
                            </button>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AutoSuggestInput;
